import firebase from "firebase";

  const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBk_od2hqSQnFBVeWo0Cv3CDNnA8somh7g",
    authDomain: "react-todo-app-74978.firebaseapp.com",
    projectId: "react-todo-app-74978",
    storageBucket: "react-todo-app-74978.appspot.com",
    messagingSenderId: "1315056240",
    appId: "1:1315056240:web:c8e14a3eaaeb4314ece2b5",
    measurementId: "G-1K69E8QXYD"
  
  });

  const db = firebaseApp.firestore();
  

  export default db;